// All the events

export const ACTIONS = {
   JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "code-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  FILE_CREATED: "file-created", // ✅ added this for real-time file sharing
  FILE_RENAMED: "file-renamed",
  FILE_DELETED: "file-deleted",
  SYNC_FILES: "sync-files",
    FILE_UPDATED: 'file-updated',     // You're using this
  FILE_SWITCHED: 'file-switched',   // You're using this
  // Room host
  HOST_CHANGED: 'host-changed',
  
  // Audio events (optional - you can keep using string literals)
  AUDIO_AVAILABLE: 'audio-available',
  AUDIO_STOPPED: 'audio-stopped',
  REQUEST_LISTEN: 'request-listen',
  SPEAKING: 'speaking',
  JOIN_AUDIO_ROOM: 'join-audio-room',
  LEAVE_AUDIO_ROOM: 'leave-audio-room',
  ALL_AUDIO_USERS: 'all-audio-users',
  USER_JOINED_AUDIO: 'user-joined-audio',
  USER_LEFT_AUDIO: 'user-left-audio',
  OFFER: 'offer',
  ANSWER: 'answer',
  ICE_CANDIDATE: 'ice-candidate',
  LISTEN_REQUEST_DENIED: 'listen-request-denied'
};
